<script>
import { RPL } from '@/config'

import SingleSelectFilter from './SingleSelectFilter.vue'

export default {
  name: 'RVBRegionsFilter',
  mixins: [SingleSelectFilter],
  computed: {
    options() {
      return RPL.map(option => {
        return {
          value: option.id,
          text: option.name,
        }
      })
    },
  },
}
</script>
